export const PseudoFolderColors = {
	EVENTS_HEX: 0x3f77dd,
	SKILLS_HEX: 0x24aa5c,
	EXTRAS_HEX: 0xe9c525,
	TRAININGS_HEX: 0xe04923,
};
